import React from 'react';

const SubscriptionSection = () => {
  const services = [
    {
      title: '개발',
      description: '웹/앱 개발, 유지보수, API 연동, 기능 추가',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
        </svg>
      ),
    },
    {
      title: '디자인',
      description: 'UI/UX 디자인, 웹디자인, 앱디자인, 배너/상세페이지',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
        </svg>
      ),
    },
    {
      title: '브랜딩',
      description: '브랜드 전략, 로고/CI, 브랜드 가이드라인, 마케팅 소재',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
        </svg>
      ),
    },
  ];

  const plans = [
    {
      title: '1개 선택',
      subtitle: '개발 / 디자인 / 브랜딩 중 택 1',
      price: '300',
      recommended: false,
      features: [
        '선택한 1개 서비스 무제한 요청',
        '전담 매니저 배정',
        '평균 48시간 내 결과물 전달',
        '월간 리포트 제공',
        '실시간 커뮤니케이션',
      ],
    },
    {
      title: '2개 선택',
      subtitle: '개발 / 디자인 / 브랜딩 중 택 2',
      price: '550',
      discount: '50만원 할인',
      recommended: true,
      features: [
        '선택한 2개 서비스 무제한 요청',
        '전담 매니저 배정',
        '평균 48시간 내 결과물 전달',
        '월간 리포트 제공',
        '실시간 커뮤니케이션',
        '서비스 간 연계 최적화',
      ],
    },
    {
      title: '3개 올인원',
      subtitle: '개발 + 디자인 + 브랜딩 모두 포함',
      price: '800',
      discount: '100만원 할인',
      recommended: false,
      features: [
        '개발 + 디자인 + 브랜딩 무제한 요청',
        '전담 매니저 배정',
        '평균 48시간 내 결과물 전달',
        '월간 리포트 제공',
        '실시간 커뮤니케이션',
        '서비스 간 연계 최적화',
        '우선 순위 처리',
      ],
    },
  ];

  return (
    <section id="subscription" className="py-20 bg-light">
      <div className="container mx-auto px-4">
        {/* 섹션 헤더 */}
        <div className="text-center mb-16">
          <span className="inline-block px-3 py-1 bg-primary/10 text-primary rounded-full text-sm font-medium mb-4">
            구독 서비스
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-dark mb-4">
            개발 / 디자인 / 브랜딩 <span className="text-primary">구독 서비스</span>
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            필요한 서비스를 구독하고, 무제한으로 요청하세요.
            전문가 팀이 비즈니스 성장에 필요한 개발, 디자인, 브랜딩을 월 구독 형태로 제공합니다.
          </p>
        </div>

        {/* 서비스 카드 3개 */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow"
            >
              <div className="w-14 h-14 bg-primary/10 rounded-lg flex items-center justify-center mb-4 text-primary">
                {service.icon}
              </div>
              <h3 className="text-xl font-bold text-dark mb-2">{service.title}</h3>
              <p className="text-gray-600 text-sm">{service.description}</p>
            </div>
          ))}
        </div>

        {/* Pricing Table */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow p-8 flex flex-col relative ${
                plan.recommended ? 'border-2 border-primary' : ''
              }`}
            >
              {/* 추천 배지 */}
              {plan.recommended && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-primary text-white text-xs font-bold px-4 py-1 rounded-full">
                  추천
                </span>
              )}

              {/* 플랜 헤더 */}
              <div className="text-center mb-6">
                <h3 className="text-xl font-bold text-dark mb-1">{plan.title}</h3>
                <p className="text-gray-500 text-sm mb-4">{plan.subtitle}</p>
                <div className="flex items-end justify-center">
                  <span className="text-4xl font-bold text-dark">{plan.price}</span>
                  <span className="text-gray-500 text-sm ml-1 mb-1">만원/월</span>
                </div>
                <p className="text-xs text-gray-400 mt-1">VAT 포함</p>
                {plan.discount && (
                  <span className="inline-block mt-2 text-xs font-medium text-primary bg-primary/10 px-3 py-1 rounded-full">
                    {plan.discount}
                  </span>
                )}
              </div>

              {/* 구분선 */}
              <div className="border-t border-gray-200 mb-6"></div>

              {/* 체크리스트 */}
              <ul className="space-y-3 flex-1">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start text-sm text-gray-600">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-primary mr-2 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    {feature}
                  </li>
                ))}
              </ul>

              {/* CTA 버튼 */}
              <div className="mt-8">
                <a
                  href="#contact"
                  className={`block text-center px-6 py-3 rounded-md font-medium transition-colors ${
                    plan.recommended
                      ? 'bg-primary text-white hover:bg-primary/90'
                      : 'bg-primary/10 text-primary hover:bg-primary/20'
                  }`}
                >
                  구독 문의하기
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SubscriptionSection;
